import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-bar"
};
const _hoisted_2 = {
  class: "nav-bar-title"
};
import utils from '@/utils/utils';
export default {
  __name: 'NavBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    }
  },
  emits: ['rightClick'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "nav-bar-left",
        onClick: _cache[0] || (_cache[0] = $event => _unref(utils).onBack())
      }, [_createVNode(_component_van_icon, {
        name: "arrow-left",
        size: "18"
      })]), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.title)), 1), _createElementVNode("div", {
        class: "nav-bar-right",
        onClick: _cache[1] || (_cache[1] = $event => emit('rightClick'))
      }, _toDisplayString(_ctx.$t(__props.rightText)), 1)]);
    };
  }
};